import { useVersionDetail, useOrgPolicySettings, isArtefactPolicyEnabled } from '@/lib/hooks'
import { PolicyOverrides } from '@/features/policies/components/PolicyOverrides'
import { Modal } from '@/shared/components/Modal'
import { PolicyResultsCard } from '@/features/modules/components/PolicyResultsCard'

/** Per-version Policies pop-out (opened from the row's "Policies" button): this version's
 *  policy results + the module-level inheritance overrides. */
export function ModulePolicyModal({ slug, name, provider, version, canAdmin, onClose }: {
  slug: string; name: string; provider: string; version: string; canAdmin: boolean; onClose: () => void
}) {
  const detail = useVersionDetail(slug, name, provider, version)
  const policySettings = useOrgPolicySettings(slug)
  const modulesEnabled = isArtefactPolicyEnabled(policySettings.data, 'modules')
  return (
    <Modal track="module_version_policies" title={`Policies · v${version}`} onClose={onClose} maxWidth={640}>
      {detail.loading ? (
        <span className="spinner" />
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          <PolicyResultsCard results={detail.data?.policy_results ?? []} enabled={modulesEnabled} />
          {detail.data?.module_id && (
            <div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--text3)', letterSpacing: '0.08em', marginBottom: 8 }}>// policy inheritance — this module</div>
              <PolicyOverrides orgId={slug} artefactType="module" instanceKey={detail.data.module_id} canAdmin={canAdmin} />
            </div>
          )}
        </div>
      )}
    </Modal>
  )
}

